var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}.cls-2{fill:#141414;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Player"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,3A27,27,0,1,1,3,30,27,27,0,0,1,30,3m0-3A30,30,0,1,0,60,30,30,30,0,0,0,30,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 30,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,30.83A42,42,0,0,0,22.72,44.26a.85.85,0,0,1-.9.24.84.84,0,0,1-.53-1.06,42.06,42.06,0,0,0,0-26.88.84.84,0,0,1,1.43-.82A42,42,0,0,0,46,29.17a.85.85,0,0,1,0,1.66Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayB);
export default __webpack_public_path__ + "static/media/play-b.4e9255cfbc5a8f7244b8f8b5454c65f4.svg";
export { ForwardRef as ReactComponent };